import * as types from '../../mutation-types'

const state = {
  deleteMessage: {
    resolve: null,
    reject: null,
    config: null,
    show: false
  }
}

const mutations = {
  [types.MAKE_DELETE_MESSAGE] (state, message) {
    state.deleteMessage.show = true
    state.deleteMessage.config = message.config
    state.deleteMessage.resolve = message.resolve
    state.deleteMessage.reject = message.reject
  },

  [types.ACCEPT_DELETE] (state, forceDelete) {
    const newConfig = Object.assign({}, state.deleteMessage.config)

    newConfig.headers['X-Strmln-Forced-Delete'] = forceDelete

    state.deleteMessage.resolve(newConfig)
    state.deleteMessage.show = false
  },

  [types.REJECT_DELETE] (state) {
    state.deleteMessage.reject()
    state.deleteMessage.show = false
  }
}

export default {
  state,
  mutations
}
